import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import MaturityIndexPage from '@/pages/MaturityIndexPage';

export default function MaturityIndexModule() {
  const tabs = [
    { id: 'benchmark', label: 'Benchmark', content: <MaturityIndexPage /> },
  ];

  return (
    <ModuleShell title="Maturity Index" subtitle="FMI-108 — the 1,000-point platform benchmark" tabs={tabs} />
  );
}
